import { formatSingaporeDate, getSingaporeDateKeyFromInstant } from "./timezone";

const UNAVAILABLE = "Date unavailable";

/**
 * Stable customer-facing delivery calendar day (`YYYY-MM-DD` in Asia/Singapore).
 *
 * Drizzle `date` columns and superjson may deliver a Date, an ISO datetime, or a
 * date-only string. Never use `String(date)` — that dumps `Mon Sep 07 2026 GMT+0800…`.
 */
export function toCustomerDeliveryDateKey(
  value: Date | string | number | null | undefined,
): string | null {
  if (value == null || value === "") return null;
  return getSingaporeDateKeyFromInstant(value);
}

/**
 * en-SG label like `7 Sep 2026`. Always a display string — never a Date or GMT dump.
 */
export function formatCustomerDeliveryDate(
  value: Date | string | number | null | undefined,
): string {
  const key = toCustomerDeliveryDateKey(value);
  if (!key) return UNAVAILABLE;
  const formatted = formatSingaporeDate(key, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
  if (!formatted || formatted === "—") return UNAVAILABLE;
  return formatted;
}
